import { Dispatch, SetStateAction } from 'react';
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import bus from '../../../assets/images/icons/bus.svg';
import chartPie from '../../../assets/images/icons/chartPie.svg';
import companySidebar from '../../../assets/images/icons/companySidebar.svg';
import downloadFile from '../../../assets/images/icons/downloadFile.svg';
import filePen from '../../../assets/images/icons/filePen.svg';
// import fileSignature from '../../../assets/images/icons/fileSignature.svg';
import fileUpload from '../../../assets/images/icons/fileUpload.svg';
import lock from '../../../assets/images/icons/lock.svg';
import map from '../../../assets/images/icons/map.svg';
import passenger from '../../../assets/images/icons/passenger.svg';
import plusSidebar from '../../../assets/images/icons/plusSidebar.svg';
import route from '../../../assets/images/icons/route.svg';
import searchSidebar from '../../../assets/images/icons/searchSidebar.svg';
import store from '../../../assets/images/icons/store.svg';
import triangulation from '../../../assets/images/icons/triangulation.svg';
import user from '../../../assets/images/icons/user.svg';
import vehicle from '../../../assets/images/icons/vehicle.svg';
import { useAppContext } from '../../../contexts/auth';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import { MenuItem } from '../styles';

interface ClientNavbarInterface {
  active: string;
  setGeneralReportsModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function ClientNavbar({ active, setGeneralReportsModalShow }: ClientNavbarInterface) {
  const isAffreightmentPageActive = active === 'Lines' || active === 'Vehicles' || active === 'Passengers' || active === 'Dashboard';
  const isTriangulationPageActive = active === 'Triangulation';

  const isWorkplacesPageActive = active === 'Workplaces';
  const isClientUsersPageActive = active === 'ClientUsers';
  // const isAutImplantationPageActive = active === 'AutImplantation';
  const isCompanyPageActive = active === 'Company';
  // const isImportVtRegistrationDataPageActive = active === 'ImportVtRegistrationData';
  const registrationsPages = ['ClientUsers', 'AutImplantation', 'Company', 'Workplaces', 'Departments', 'ImportVtRegistrationData'];
  const isSomeRegistrationPageActive = registrationsPages.includes(active);

  const isNewConsultPageActive = active === 'NewConsult';
  const isImportConsultsFilePageActive = active === 'ImportConsultsFile';
  const isSearchConsultsPageActive = active === 'SearchConsults';
  const consultsPages = ['NewConsult', 'SearchConsults', 'ImportConsultsFile', 'Reclamations'];
  const isSomeConsultPageActive = consultsPages.includes(active);

  const { permissions, services } = useGetGeneralAppData();
  const companyPermissions = permissions.find((x) => x.codPag === 1);
  const clientUsersPermissions = permissions.find((x) => x.codPag === 3);
  const workplacesPermissions = permissions.find((x) => x.codPag === 4);
  // const autImplantationPermissions = permissions.find((x) => x.codPag === 5);
  const routingPermissions = permissions.find((x) => x.codPag === 6);
  const routingFilePermissions = permissions.find((x) => x.codPag === 7);
  const affreightmentsDashboardPermissions = permissions.find((x) => x.codPag === 9);
  const affreightmentsLinesPermissions = permissions.find((x) => x.codPag === 10);
  const affreightmentsVehiclesPermissions = permissions.find((x) => x.codPag === 11);
  const affreightmentsPassengersPermissions = permissions.find((x) => x.codPag === 12);
  const triangulationPermissions = permissions.find((x) => x.codPag === 13);
  const generalReportsPermissions = permissions.find((x) => x.codPag === 14);

  const routingServicesCode = [12, 2, 3, 15, 10, 11];
  const hasSomeRoutingService = !services || services.some((service) => routingServicesCode.includes(service.codServ));
  // const hasAutImplantationService = !services || services.some((service) => service.codServ === 18);
  const hasAffreightmentsService = !services || services.some((service) => service.codServ === 14);
  const hasAffreightmentsAccessControlService = !services || services.some((service) => service.codServ === 16);
  const hasTriangulationService = !services || services.some((service) => service.codServ === 17);

  const hasSomeRegistrationPage = companyPermissions?.vizualizar ||
  clientUsersPermissions?.vizualizar ||
  workplacesPermissions?.vizualizar;

  const { isDirectLogin } = useAppContext();

  return (
    <>
      {/* Change Password */}
      {!isDirectLogin && (
        <Link to="/changePassword">
          <MenuItem active={active === 'ChangePassword'}>
            <img src={lock} alt="home" />
          Alterar Senha
          </MenuItem>
        </Link>
      )}


      {/* Registrations */}
      {hasSomeRegistrationPage && (
        <Accordion defaultActiveKey={isSomeRegistrationPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={filePen} alt="bus" />
                {' '}
              Cadastros
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {(companyPermissions && companyPermissions.vizualizar) && (
                <Link to="/company">
                  <MenuItem active={isCompanyPageActive}>
                    <img src={companySidebar} alt="company" />
                  Empresa
                  </MenuItem>
                </Link>
              )}

              {(clientUsersPermissions && clientUsersPermissions.vizualizar) && (
                <Link to="/clientUsers">
                  <MenuItem active={isClientUsersPageActive}>
                    <img src={user} alt="user" />
                  Usuários clientes
                  </MenuItem>
                </Link>
              )}

              {workplacesPermissions && workplacesPermissions.vizualizar && (
                <Link to="/workplaces">
                  <MenuItem active={isWorkplacesPageActive}>
                    <img src={store} alt="workplaces" />
                  Locais de trabalho
                  </MenuItem>
                </Link>
              )}

              {/* <Link to="/departments">
              <MenuItem active={isDepartmentsPageActive}>
                <img src={groupLine} alt="departments" />
                Departamentos
              </MenuItem>
            </Link> */}

              {/* {(autImplantationPermissions && autImplantationPermissions.vizualizar && hasAutImplantationService) && (
              <Link to="/autImplantation">
                <MenuItem active={isAutImplantationPageActive}>
                  <img src={fileSignature} alt="fileSignature" />
                Implantação Automática
                </MenuItem>
              </Link>
            )} */}

              {/* <Link to="/importVtRegistrationData">
                <MenuItem active={isImportVtRegistrationDataPageActive}>
                  <img src={fileUpload} alt="newConsult" />
                  Recadastramento de VT
                </MenuItem>
              </Link> */}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Consults */}
      {hasSomeRoutingService && (
        <Accordion defaultActiveKey={isSomeConsultPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={map} alt="bus" />
                {' '}
                Roteirização
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {(routingPermissions?.incluir && routingPermissions?.vizualizar) && (
                <Link to="/consults/new">
                  <MenuItem active={isNewConsultPageActive}>
                    <img src={plusSidebar} alt="newConsult" />
                    Nova Consulta
                  </MenuItem>
                </Link>
              )}

              {routingFilePermissions?.incluir && (
                <Link to="/consults/file">
                  <MenuItem active={isImportConsultsFilePageActive}>
                    <img src={fileUpload} alt="newConsult" />
                    Importar Arquivo
                  </MenuItem>
                </Link>
              )}

              {routingPermissions?.vizualizar && (
                <Link to="/consults/search">
                  <MenuItem active={isSearchConsultsPageActive}>
                    <img src={searchSidebar} alt="searchConsult" />
                    Pesquisar Consultas
                  </MenuItem>
                </Link>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Affreightments */}
      {hasAffreightmentsService && (
        <Accordion defaultActiveKey={isAffreightmentPageActive ? '0' : undefined} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MenuItem>
                <img src={bus} alt="bus" />
                {' '}
                Fretamentos
              </MenuItem>
            </Accordion.Header>
            <Accordion.Body>
              {(affreightmentsDashboardPermissions && affreightmentsDashboardPermissions.vizualizar && hasAffreightmentsAccessControlService) && (
                <Link to="/dashboard">
                  <MenuItem active={active === 'Dashboard'}>
                    <img src={chartPie} alt="dashboard" />
                    <label>Dashboard</label>
                  </MenuItem>
                </Link>
              )}

              {affreightmentsLinesPermissions && affreightmentsLinesPermissions.vizualizar && (
                <Link to="/lines">
                  <MenuItem active={active === 'Lines'}>
                    <img src={route} alt="bus" />
                    <label>Linhas</label>
                  </MenuItem>
                </Link>
              )}

              {(affreightmentsVehiclesPermissions && affreightmentsVehiclesPermissions.incluir && hasAffreightmentsAccessControlService) && (
                <Link to="/vehicles">
                  <MenuItem active={active === 'Vehicles'}>
                    <img src={vehicle} alt="bus" />
                    <label>Veículos</label>
                  </MenuItem>
                </Link>
              )}

              {(affreightmentsPassengersPermissions && affreightmentsPassengersPermissions.vizualizar && hasAffreightmentsAccessControlService) && (
                <Link to="/passengers">
                  <MenuItem active={active === 'Passengers'}>
                    <img src={passenger} alt="passageiros" />
                    <label>Passageiros</label>
                  </MenuItem>
                </Link>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}

      {/* Triangulation */}
      {(triangulationPermissions && triangulationPermissions.vizualizar && hasTriangulationService) && (
        <Link to="/triangulation">
          <MenuItem active={isTriangulationPageActive}>
            <img src={triangulation} alt="home" />
            Triangulação
          </MenuItem>
        </Link>
      )}

      {generalReportsPermissions && generalReportsPermissions.vizualizar && (
        <MenuItem active={false} onClick={() => setGeneralReportsModalShow(true)}>
          <img src={downloadFile} alt="" />
          Relatórios Gerais
        </MenuItem>
      )}
    </>
  );
}
